import { Icon } from '@iconify/react';
import { Box, Button, CircularProgress, Stack, Typography } from "@mui/material";
import { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppContext } from '../../Base';
import { displayNumber } from '../../consts/helpers';
import ResultGaugeChart from '../charts/ResultGaugeChart';

export default function ResultsStage1({ callCalcAPI, handleProceed }) {
    const navigate = useNavigate();
    const setFootprint = useContext(AppContext).setFootprint;
    
    const [result, setResult] = useState('');
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        setResult('');
        setIsLoading(true);
        callCalcAPI().then( data => {
            setResult(data?.S1_emissions ? data?.S1_emissions*12 : 0);
            setFootprint(data?.S1_emissions ? data?.S1_emissions*12 : 0);
            setIsLoading(false);
        });
    }, [callCalcAPI, setFootprint]);
    
    return (
        <Box sx={{ flex: 'auto' }} className='spread-y'>
        <Stack spacing={3}>
            <Box className='centered-container' sx={{ borderRadius: 'var(--container-rad)', backgroundColor: 'var(--pri-purple)', p: 2, color: 'white', textAlign: 'center' }}>
                <Typography variant='body2'>
                    Your Annual Carbon Footprint<br/>
                    is estimated to be
                </Typography>
                <Typography variant='h5'>
                    <Icon icon="material-symbols:barefoot" color='var(--pri-green)'/>&nbsp;
                    { isLoading ?
                        <CircularProgress size={20} color='inherit' />
                        :
                        <>{displayNumber(result, 3)} tCO<sub>2</sub>e/year</>
                    }
                </Typography>
                <ResultGaugeChart resultValue={result} />
            </Box>
        </Stack>
        { !isLoading &&
            <Stack spacing={2}>
                <Typography variant="body2" fontSize={12} gutterBottom>
                    Would you like to provide more data for a more personalized carbon footprint estimation?
                </Typography>
                <Button className="pill_btn pri_btn" onClick={handleProceed}>Provide more data</Button>
                <Button className="pill_btn pri_btn outline_btn" onClick={() => navigate('/')}>Back to homepage</Button>
            </Stack>
        }
        </Box>
    )
}